import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateDecimals',
  standalone: true,
})
export class TruncateDecimalsPipe implements PipeTransform {

  transform(value: any, decimalPlaces: number = 2): string {
	const parts = value.toString().split('.');
	if (parts.length === 1) {
		return value.toString();
	}else {
	    const truncatedDecimal = parts[1].substring(0, decimalPlaces);
		return `${parts[0]}.${truncatedDecimal}`;
	}
  }
}
